/** User-facing names for headline ``profit_rating`` / ``epr`` (API fields unchanged). */
export const PR_FULL = 'Profitability Rating';
export const PR_SHORT = 'PR';
export const SPS_FULL = 'Straight Profitability Score';
export const SPS_SHORT = 'SPS';
export const PPS_FULL = 'Parlay Profitability Score';
export const PPS_SHORT = 'PPS';

/** @deprecated Use PR_FULL */
export const WPR_FULL = PR_FULL;
/** @deprecated Use PR_SHORT */
export const WPR_SHORT = PR_SHORT;
/** @deprecated Use PR_FULL */
export const EPR_FULL = PR_FULL;
/** @deprecated Use PR_SHORT */
export const EPR_SHORT = PR_SHORT;

export function eprClassLabel(
  eprClass: string | null | undefined,
): string | null {
  switch (eprClass) {
    case 'strong_singles':
      return 'Strong Straight';
    case 'strong_parlays':
      return 'Strong Parlays';
    case 'both':
      return 'Strong Straight & Parlays';
    default:
      return null;
  }
}
